
              $(".popupoverlay").click(function(){
              $('.ccs-popupb').hide();
                 $(".ccs-popupone").hide();
                 $(".popupoverlay").hide();
              });
             $(".popupclose").click(function(){
              $('.ccs-popupb').hide();
                $(".ccs-popupone").hide();
                $(".popupoverlay").hide();
              });
             $(".ccspopupopen").click(function(){
               $(".popupoverlay").show();
              $(this).parent().next('.ccs-popupb').show();

              });
            $(".ccspopupopena").click(function(){
               $(".popupoverlay").show();
              $(this).parent().find('.ccs-popupb').show();

              });
            
             $("#ccspcb").click(function(){
               $(".popupoverlay").show();
              $('.ccs-popupo').show();

              });
            
             $("#ccsdbp").click(function(){
               $(".popupoverlay").show();
              $('.ccs-popupp').show();

              });
         
            var $root = $('html, body');

$('a[href^="#"]').click(function () {
    $root.animate({
        scrollTop: $( $.attr(this, 'href') ).offset().top - 100
    }, 500);

    return false;
});
        